export const currentRestaurantMonth = (now = new Date()): string =>
  new Intl.DateTimeFormat('sv-SE', {
    timeZone: 'Europe/Kyiv',
    year: 'numeric',
    month: '2-digit',
  }).format(now);

export const isRestaurantMonth = (value: unknown): value is string =>
  typeof value === 'string' && /^\d{4}-(0[1-9]|1[0-2])$/.test(value) &&
  value >= '2000-01' && value <= '2200-12';
